export class ShareModel {
    language: string;
    isrtl: boolean;
}
